import { useState } from "react";

import {
  EMPTY_SUCCESSFACTORS_INTEGRATION,
  SuccessFactorsIntegration,
  SuccessFactorsIntegrationContext,
} from "./SuccessFactorsIntegrationContext";
import { SuccessFactorsSetupStep } from "./components/SuccessFactorsSetupStep";

export function SuccessFactorsIntegrationSetupPage() {
  const [integrationData, setIntegration] = useState<SuccessFactorsIntegration>(
    EMPTY_SUCCESSFACTORS_INTEGRATION
  );

  return (
    <SuccessFactorsIntegrationContext.Provider
      value={{
        integrationData,
        setIntegration,
      }}
    >
      <SuccessFactorsSetupStep />
    </SuccessFactorsIntegrationContext.Provider>
  );
}
